/**
 * In-memory flag so Header can block navigation when SFTP create/detail has unsaved edits.
 * Updated by SftpManagementPage; cleared on unmount.
 */
let sftpUnsaved = false;

export function setSftpNavigationUnsaved(dirty: boolean): void {
  sftpUnsaved = dirty;
}

export function getSftpNavigationUnsaved(): boolean {
  return sftpUnsaved;
}
